// extracted by mini-css-extract-plugin
export default {"headerTab":"header_headerTab__YkhXY","tab":"header_tab__SJI-D","tabItem":"header_tabItem__S5iqg","right":"header_right__8Wq2Z"};